import { createRoot, hydrateRoot, type Root } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

const root = document.getElementById("root");
if (root) {
  const pageWindow = window as typeof window & { __augenweideRoot?: Root };
  if (pageWindow.__augenweideRoot) pageWindow.__augenweideRoot.render(<App />);
  else if (root.innerHTML.trim()) pageWindow.__augenweideRoot = hydrateRoot(root, <App />);
  else {
    pageWindow.__augenweideRoot = createRoot(root);
    pageWindow.__augenweideRoot.render(<App />);
  }
}
